export default "__VITE_ASSET___7l6IKig__"